module.exports = __webpack_public_path__ + "img/7.36d7e3df.jpeg";